import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActionBarListButtonsComponent} from './action-bar-list-buttons/action-bar-list-buttons.component';
import {ActionBarComponent} from './action-bar.component';
import {InlineSVGModule} from "ng-inline-svg-2";
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {CommonSharedModule, HelpModule} from 'common-shared';
import {TranslocoModule} from "@jsverse/transloco";
import { ToolbarComponent } from './toolbar/toolbar.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { PageSearchComponent } from './page-search/page-search.component';
import { ToolbarListButtonsComponent } from './toolbar-list-buttons/toolbar-list-buttons.component';
import { ToolbarEditButtonsComponent } from './toolbar-edit-buttons/toolbar-edit-buttons.component';
import {NgArrayPipesModule} from "ngx-pipes";
import {UserHasPrivilegePipe} from "../../system/user/user-has-privilege.pipe";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    InlineSVGModule,
    CommonSharedModule,
    TranslocoModule,
    NgArrayPipesModule,
    UserHasPrivilegePipe,
    HelpModule
  ],
  exports: [
    ActionBarComponent,
    ActionBarListButtonsComponent,
    ToolbarComponent,
    BreadcrumbsComponent,
    PageSearchComponent,
    ToolbarListButtonsComponent,
    ToolbarEditButtonsComponent
  ],
  declarations: [
    ActionBarListButtonsComponent,
    ActionBarComponent,
    ToolbarComponent,
    BreadcrumbsComponent,
    PageSearchComponent,
    ToolbarListButtonsComponent,
    ToolbarEditButtonsComponent
  ],
  providers: []
})
export class ActionBarModule {
}
